import { ZSNCampaign, ZSNOrder } from '../../../models/zsn.model';
import { correctDate } from '../../../utils/utils';

export class ZSNUtils {
  public static isOrderEditable(order: ZSNOrder): boolean {
    const today = correctDate(new Date());
    const campaign = order.campaign;
    const config = campaign.configuration;
    return today <= config.endingOn;
  }

  public static isCampaignCurrentlyOpen(campaign: ZSNCampaign): boolean {
    const today = correctDate(new Date());
    const config = campaign.configuration;
    return config.startingOn <= today && (config.endingOn === null || config.endingOn >= today);
  }
}
